import React from 'react';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-bootstrap/Pagination';

class UnitManage extends React.Component {

    render() {
        return (
            <>
                <div className='custom-block mb-4'>
                    <div className='row align-items-end'>
                        <Form.Group className='col-12 col-md-6 col-lg-4 col-xl-4'>
                            <Form.Label>ชื่อหน่วยของตัวชี้วัด</Form.Label>
                            <Form.Control type='text' placeholder='ชื่อหน่วยของตัวชี้วัด' />
                        </Form.Group>
                        <Form.Group className='col-12 col-md-6 col-lg-4 col-xl-4'>
                            <Form.Label>ประเภทของหน่วย</Form.Label>
                            <Form.Control as='select'>
                                <option>กรุณาเลือก</option>
                                <option>Quality</option>
                                <option>Quantity</option>
                            </Form.Control>
                        </Form.Group>
                        <div className='col-12 col-lg-3 col-xl-3 form-group text-center'>
                            <button type='button' className='mr-2 btn btn-outline-primary'>ค้นหา</button>
                            <button type='button' className='mr-2 btn btn-outline-primary'>ยกเลิก</button>
                        </div>
                    </div>
                </div>

                <div className='custom-block mb-4'>
                    <Card className="card-custom-table">
                        <Card.Header>
                            <button type='button' className='btn btn-outline-primary'>เพิ่มหน่วยตัวชี้วัด</button>
                            <div className="float-right">
                                <div className="d-inline-block mr-1">แสดง </div>
                                <select className="form-control d-inline-block" onChange={this.changeOffset} style={{ width: '75px' }}>
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={15}>15</option>
                                    <option value={20}>20</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                                <div className="d-inline-block ml-1">Entries</div>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <Table striped bordered hover className="mb-0">
                                <thead>
                                    <tr style={{ textAlign: 'center' }}>
                                        <th style={{ width: '10%' }}>ลำดับ</th>
                                        <th style={{ width: '20%' }}>ชื่อหน่วยของตัวชี้วัด</th>
                                        <th style={{ width: '15%' }}>ประเภทของหน่วยวัด</th>
                                        <th style={{ width: '10%' }}>แก้ไข/ลบ</th>
                                    </tr>
                                </thead>
                                <tbody className='text-center'>
                                    <tr>
                                        <td>1</td>
                                        <td>ล้าน ลบ.ม.</td>
                                        <td>ปริมาณ</td>
                                        <td align='center'>
                                            <button onClick={this.showModalFunction} className='btn btn-outline-secondary mr-1'><i className='fa fa-pencil'></i></button>
                                            <button onClick={this.showModalFunction} className='btn btn-outline-danger'><i className='fa fa-trash'></i></button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>ความสำเร็จ</td>
                                        <td>คุณภาพ</td>
                                        <td align='center'>
                                            <button onClick={this.showModalFunction} className='btn btn-outline-secondary mr-1'><i className='fa fa-pencil'></i></button>
                                            <button onClick={this.showModalFunction} className='btn btn-outline-danger'><i className='fa fa-trash'></i></button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>3</td>
                                        <td>ลบ.ม.</td>
                                        <td>ปริมาณ</td>
                                        <td align='center'>
                                            <button onClick={this.showModalFunction} className='btn btn-outline-secondary mr-1'><i className='fa fa-pencil'></i></button>
                                            <button onClick={this.showModalFunction} className='btn btn-outline-danger'><i className='fa fa-trash'></i></button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>4</td>
                                        <td>ลุ่มน้ำ</td>
                                        <td>ปริมาณ</td>
                                        <td align='center'>
                                            <button onClick={this.showModalFunction} className='btn btn-outline-secondary mr-1'><i className='fa fa-pencil'></i></button>
                                            <button onClick={this.showModalFunction} className='btn btn-outline-danger'><i className='fa fa-trash'></i></button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>5</td>
                                        <td>ความพอใจ</td>
                                        <td>คุณภาพ</td>
                                        <td align='center'>
                                            <button onClick={this.showModalFunction} className='btn btn-outline-secondary mr-1'><i className='fa fa-pencil'></i></button>
                                            <button onClick={this.showModalFunction} className='btn btn-outline-danger'><i className='fa fa-trash'></i></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Card.Body>
                        <Card.Footer>
                            <div className='d-inline-block'>
                                รายการที่แสดง : 1 - 5
                    </div>
                            <Pagination className="mb-0 float-right">
                                <Pagination.Item >1</Pagination.Item>
                                <Pagination.Item >2</Pagination.Item>
                                <Pagination.Next />
                                <Pagination.Last />
                            </Pagination>
                        </Card.Footer>
                    </Card>
                </div>
            </>
        );
    }
}

export default UnitManage;